/* eslint max-len: 0 */
const pageEvents = {
  BOP_ADVERTISED_PRODUCTS_DISPLAYED: 'Advertised products displayed',
  BOP_PROMOTION_CLICKED: 'Clicked promo',
  BOP_SMART_PASS_PROMOTION_CLICKED: 'Clicked smart pass promo',
  BOP_SECTION_EXPANDED: 'Show more clicked',
  BOP_SECTION_COLLAPSED: 'Show less clicked',
  BOP_QUANTITY_RESTRICTION_EXCEEDED: 'Quantity restriction text triggered',
  BOP_SHOW_ALL_COUPONS_CLICKED: 'Clicked coupons',
  BOP_IMAGE_SELECTED: 'Photo from gallery viewed',
  BOP_STICKY_SHOWN: 'Bop sticky ribbon shown',
  BOP_STICKY_LINK_CLICKED: 'Bop sticky ribbon link clicked',
  BOP_STICKY_PRODUCTS_TO_BUY_CLICKED: 'Bop sticky ribbon \'Products to buy\' clicked',
  BOP_SIMILAR_PRODUCTS_SHOWN: 'Similar products displayed',
  BOP_YOU_MIGHT_LIKE_SHOWN: 'YML displayed',
};

const pageEventFields = {
  PROMO_ID: 'PROMO_ID',
  CLUB_SCHEME_ID: 'CLUB_SCHEME_ID',
  OFFER_TYPE: 'OFFER_TYPE',
  BOP_COMPONENT: 'BOP_COMPONENT',
  PER_COUPON_ID: 'PER_COUPON_ID',
  IMG_HASH: 'IMG_HASH',
  IMG_POSITION: 'IMG_POSITION',
  STICKY_LINK_LABEL: 'LINK_LABEL',
};

const bopComponents = {
  GENERAL_NUTRITION_INFO: 'GENERAL_NUTRITION_INFO',
  NUTRITION_DETAILS: 'NUTRITION_DETAILS',
  PRODUCT_DETAILS: 'PRODUCT_DETAILS',
  PRODUCT_DESCRIPTION: 'PRODUCT_DESCRIPTION',
  REVIEW_LIST: 'REVIEW_LIST',
};

export {
  pageEvents,
  pageEventFields,
  bopComponents,
};
